<div class="circle-progress header-element" *ngIf="!mobile; else mobileTemplate">
  <svg width="40" height="40" viewPort="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle r="16" cx="20" cy="20" fill="transparent" [attr.stroke-dasharray]="16 * 2 * 3.1415" stroke-dashoffset="0"></circle>
    <circle class="bar" r="16" cx="20" cy="20" fill="transparent" [attr.stroke-dasharray]="16 * 2 * 3.1415" [attr.stroke-dashoffset]="16 * 2 * 3.1415 - validityRate * 16 * 2 * 3.1415"></circle>
  </svg>
  <span class="time">{{ remainingTime }}</span>
  <span *ngIf="checkIsPreco()">{{ formattedValidityEndDate }}</span>
</div>

<ng-template #mobileTemplate>
  <div class="circle-progress header-element mobile">
    <svg width="16" height="16" viewPort="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle r="6" cx="8" cy="8" fill="transparent" [attr.stroke-dasharray]="6 * 2 * 3.1415" stroke-dashoffset="0"></circle>
      <circle class="bar" r="6" cx="8" cy="8" fill="transparent" [attr.stroke-dasharray]="6 * 2 * 3.1415" [attr.stroke-dashoffset]="6 * 2 * 3.1415 - validityRate * 6 * 2 * 3.1415"></circle>
    </svg>
    <span class="time">{{ remainingTime  }}</span>
    <span *ngIf="checkIsPreco()">{{ formattedValidityEndDate }}</span>
  </div>
</ng-template>